// Ganti dengan Contract Address EmoFi Anda yang baru di-deploy
export const CONTRACT_ADDRESS = "0x7ee07cD7047765384878EC0F3B80981107961bE2"; 

export const AIRDROP_CONTRACT_ADDRESS = CONTRACT_ADDRESS;
export const TOKEN_CONTRACT_ADDRESS = CONTRACT_ADDRESS;

export const AIRDROP_ABI = [
  {
    "inputs": [
      {
        "internalType": "address",
        "name": "inviter",
        "type": "address"
      }
    ],
    "name": "claim",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
];

export const TOKEN_ABI = [
  {
    "inputs": [],
    "name": "swap",
    "outputs": [],
    "stateMutability": "payable",
    "type": "function"
  }
];